<div class="replays-modal">
  <h2 md-dialog-title>MAX Additional pictures</h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <table *ngIf="!loading">
      <thead>
        <tr>
          <th>Image set</th>
          <th>Lock</th>
          <th>Original</th>
          <th>Format</th>
          <th>Picture</th>
          <th>Multilingual</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pictureSet of pictureSets; let i = index">
          <td>
            <md-select
              [(ngModel)]="pictureSet.setId"
              placeholder="Select a picture set"
              (change)="openImageSetModal(pictureSet.setId)"
            >
              <md-option [value]="0">Select a picture set</md-option>
              <md-option
                *ngFor="let set of selectablePictureSets"
                (click)="changeSelectedPictureSet()"
                [disabled]="isSetSelected(set.id)"
                [value]="set.id"
              >
                {{ set.name }}
              </md-option>
            </md-select>
          </td>
          <td>
            <md-icon
              *ngIf="
                getPictureByFormat(pictureSet.pictures, 'Original') &&
                getPictureByFormat(pictureSet.pictures, 'Original').isLocked
              "
              (click)="toggleLockPicture(pictureSet.pictures, false)"
              >lock</md-icon
            >
            <md-icon
              *ngIf="
                getPictureByFormat(pictureSet.pictures, 'Original') &&
                !getPictureByFormat(pictureSet.pictures, 'Original').isLocked
              "
              (click)="toggleLockPicture(pictureSet.pictures, true)"
              >lock_open</md-icon
            >
          </td>
          <td>
            <button
              *ngIf="!getPictureByFormat(pictureSet.pictures, 'Original')"
              md-raised-button
              color="accent"
              [disabled]="pictureSet.setId === 0"
              (click)="openImageSetModal(pictureSet.setId)"
            >
              Add pictures
            </button>
            <img
              *ngIf="getPictureByFormat(pictureSet.pictures, 'Original')"
              [src]="getPictureSourceByFormat(pictureSet.pictures, 'Original')"
              (click)="openImageSetModal(pictureSet.setId)"
              height="80"
              width="110"
            />
          </td>
          <td>
            <span *ngIf="pictureSet.pictures[1]?.pictureFormatName">
              {{ pictureSet?.pictures[1]?.pictureFormatName }}
            </span>
          </td>
          <td>
            <img
              *ngIf="
                getPictureByFormat(
                  pictureSet.pictures,
                  pictureSet.pictures[1]?.pictureFormatName
                )
              "
              [src]="
                getPictureSourceByFormat(
                  pictureSet.pictures,
                  pictureSet.pictures[1]?.pictureFormatName
                )
              "
              (click)="openImageSetModal(pictureSet.setId)"
              height="80"
              width="110"
            />
          </td>
          <td>
            <button
              md-raised-button
              color="primary"
              [disabled]="check(pictureSet.pictures)"
              (click)="multilingual(pictureSet)"
            >
              <md-icon>language</md-icon>
              Multilingual edition
            </button>
          </td>
          <td>
            <md-icon
              style="cursor: pointer"
              (click)="deleteSet(pictureSet.setId)"
              >delete</md-icon
            >
          </td>
        </tr>
      </tbody>
    </table>
  </md-dialog-content>
  <md-dialog-actions *ngIf="!loading">
    <div class="actions">
      <div
        *ngIf="pictureSets.length < selectablePictureSets.length"
        style="justify-content: flex-start"
      >
        <button
          md-raised-button
          color="accent"
          [disabled]="!hasSetId() && !areSetIdsUnique()"
          (click)="addRow()"
        >
          Add pictures
        </button>
      </div>
      <div>
        <button md-raised-button (click)="close()">
          <md-icon>cancel</md-icon>
          Cancel
        </button>
        <button
          [disabled]="
            !isPictureSetNotEmpty() || (!hasSetId() && !areSetIdsUnique())
          "
          md-raised-button
          color="accent"
          (click)="save(false)"
        >
          <md-icon>save</md-icon>
          Save this program only
        </button>
        <button
          [disabled]="
            !isPictureSetNotEmpty() ||
            (!hasSetId() && hasReplays && !areSetIdsUnique()) ||
            (programArticle.spev.id <= 0 &&
              (!programArticle.contentId || programArticle.contentId === '0') &&
              !programArticle.btSportProductCode) ||
            programArticle.channel.id > 20000
          "
          md-raised-button
          color="accent"
          (click)="save(true)"
        >
          <md-icon>save</md-icon>
          Save all replays
        </button>
      </div>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/additional-pictures-modal/additional-pictures-modal.component.html